var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"double-scroll-container"},[_c('div',{ref:"topScroll",staticClass:"double-scroll-top",on:{"scroll":_vm.handleTopScroll}},[_c('div',{style:({ width: _vm.scrollWidth + 'px', height: '1px' })})]),_vm._v(" "),_c('div',{ref:"content",staticClass:"double-scroll-content",on:{"scroll":_vm.handleBottomScroll}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }